import { Inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { Constants } from '@app/common/constants';
import { TrackingEvent } from '@app/models/tracking-event';
import { FeatureSettingsStoreService } from '@app/services/feature-settings-store.service';
import { UserChannelTermsService } from '@app/services/user-channel-terms.service';
import { BaseTrackingService } from '@app/tracking/base-tracking.service';
import { Environment } from '@environments/interface.environment';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppInsightsService implements BaseTrackingService {

  appInsights: ApplicationInsights;
  routerSubscription: Subscription;
  loadStartTime: number;
  loadTime: number;

  constructor(@Inject(CUSTOMERENVIRONMENT) private environment: Environment,
              private titleService: Title,
              private featureSettingsStoreService: FeatureSettingsStoreService,
              private router: Router,
              private userChannelTermsService: UserChannelTermsService) {
    if (this.featureSettingsStoreService.state.appInsightsTrackingKey) {
      this.appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: this.featureSettingsStoreService.state.appInsightsTrackingKey,
          enableDebug: !this.environment.production
        }
      });

      this.appInsights.loadAppInsights();

      // push user channels to azure insight to use them later to plot a charts in editor dash board
      this.userChannelTermsService.getUserChannelTerms()
        .subscribe((channels) => {

          this.appInsights.trackEvent({
            name: Constants.TRACKING_EVENT_TYPE_WORKPLACE_USER_CHANNELS, properties: {
              channelTermId: channels.map(channel => channel.ChannelTermId),
            }
          });
        });

      // track router events
      this.router.events
        .pipe(
          filter(event => event instanceof NavigationStart))
        .subscribe(() => {
          this.loadStartTime = Date.now();
          this.loadTime = null;
        });

      this.router.events.pipe(
        filter(event => event instanceof NavigationError || event instanceof NavigationEnd))
        .subscribe(
          (event) => {
            this.loadTime = Date.now() - this.loadStartTime;
            this.loadStartTime = null;
            if (event instanceof NavigationEnd) {
              this.trackRouterEvent(event);
            }
          });
    }
  }

  public trackRouterEvent(event: NavigationEnd): void {
    if (this.appInsights) {
      const headerTitle = this.titleService.getTitle();
      this.appInsights.trackPageView({ uri: event.urlAfterRedirects, name: headerTitle, properties: { duration: this.loadTime } });
    }
  }

  trackEvent(event: TrackingEvent): void {
    if (this.appInsights) {
      event.properties.currentRoute = this.router.url;
      this.appInsights.trackEvent({ name: event.name, properties: event.properties });
    }
  }

  trackException(): void {
    throw new Error('Method not implemented.');
  }
}
